



















import { defineComponent } from 'vue';

import { ReceiveType } from '../types';

import i18n from '@/translate/lang';
import { appStoreMapper } from 'src/store/appstore';
import { catalogStoreMapper } from '../store';
import { checkWorkingTime, getWorkingTimeFormatted } from '@/utils';
import getBranchScheduleFormatted from '@/utils/getBranchScheduleFormatted';

export default defineComponent({
  name: 'WorkingTime',
  props: {
    checkDayAndTime: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    ReceiveType,
  }),
  computed: {
    visible(): boolean {
      return this.checkDayAndTime ? !this.isWorkingTime : true;
    },
    closedText(): string {
      let text = '';

      if (this.receive === ReceiveType.pickup) {
        text = this.settings.pickup?.closedText ?? '';
      } else if (this.receive === ReceiveType.delivery) {
        text = this.settings.delivery?.closedText ?? '';
      }

      return text || i18n.t(`global.branch.${this.receive}Schedule.closed`).toString();
    },
    closed(): boolean {
      return !this.isWorkingTime;
    },
    formattedSchedule(): string {
      if (!this.deliveryPickupOrDeliveryBranch || !this.receive) {
        return '';
      }

      const schedule = checkWorkingTime({
        branchOrSchedule: this.deliveryPickupOrDeliveryBranch,
        timezoneOptions: this.timeZoneOptions,
        type: this.receive,
      });

      return getWorkingTimeFormatted(
        schedule,
        this.timeZoneOptions,
        this.$i18n,
        this.receive,
      );
    },
    ...appStoreMapper.mapGetters(['timeZoneOptions']),
    ...catalogStoreMapper.mapGetters([
      'isWorkingTime',
      'settings',
      'deliveryPickupOrDeliveryBranch',
    ]),
    ...catalogStoreMapper.mapState(['receive']),
  },
  methods: {
    onScheduleClick() {
      if (this.deliveryPickupOrDeliveryBranch) {
        this.$f7.dialog.alert(
          getBranchScheduleFormatted(
            this.deliveryPickupOrDeliveryBranch,
            this.timeZoneOptions,
            this.$i18n,
            this.receive,
          ),
          this.$t(`modules.catalog.receiveTypes.${this.receive}`).toString(),
        );
      }
    },
  },
});
